import { create } from 'zustand';

import { TRAILER_LOAD_MODE } from '@/features/shared/constants';

type UseCommonCrossingInfoBannerState = {
  trailerLoadMode?: TRAILER_LOAD_MODE;
  direction?: string;
};

export const useCommonCrossingInfoBannerState = create<UseCommonCrossingInfoBannerState>(() => ({}));
